const API_BASE = import.meta.env.VITE_PUBLIC_API_URL || "/api";

interface ApiResponse<T = any> {
  success: boolean;
  error?: string;
  [key: string]: any;
}

async function apiCall<T = ApiResponse>(
  endpoint: string,
  body?: Record<string, unknown>
): Promise<T> {
  const url = `${API_BASE}${endpoint}`;

  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });

  return res.json();
}

// ===== Admin =====
export async function adminLogin(username: string, password: string) {
  return apiCall("/admin/login", { username, password });
}

export async function adminApiCall(action: string, payload?: Record<string, unknown>) {
  const token = localStorage.getItem("admin_token");
  if (!token) return { success: false, error: "\u672a\u767b\u5f55" };

  return apiCall("/admin", { token, action, ...payload });
}

// ===== Client =====
export async function clientLogin(phone: string, password: string) {
  return apiCall("/client/login", { phone, password });
}

export async function clientDashboard(token: string) {
  return apiCall("/client/dashboard", { token });
}

export async function clientNotifications(token: string, filter?: string) {
  return apiCall("/client/notifications", { token, p_token: token, filter: filter || "all" });
}

export async function markNotificationRead(token: string, notificationId: number) {
  return apiCall("/client/notifications/read", { token, notification_id: notificationId });
}

export async function markAllNotificationsRead(token: string) {
  return apiCall("/client/notifications/read-all", { token });
}

export { apiCall, API_BASE };